<template>
  <div class="login-page-container d-flex align-items-center justify-content-center min-vh-100 bg-light view-user-login">
    <div class="login-box" style="width: 100%; max-width: 400px;">
      <b-card class="shadow">
        <b-card-body>
          <div class="row">
            <div class="col-12 text-center mb-3">
              <img
                class="logo-login-img"
                src="@/assets/img/dentcloud-logo-darkblue.png"
              />
              <h3 class="logo-caption mt-2" style="color: #38689C; font-weight: bold;">
                <span>DentCloud</span>
              </h3>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div
                class="alert alert-warning alert-dismissible fade show"
                role="alert"
                v-if="statusLogin"
              >
                {{ ERROR_MESSAGES.INVALID_CREDENTIALS_CHECK }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                  @click="setStatusLogin"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
          </div>
          <b-form @submit.prevent="submit" autocomplete="off">
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label for="email">อีเมลล์</label>
                  <div class="input-group">
                    <input
                      id="login-input-login-view"
                      class="form-control form-control-sm"
                      v-model.trim="loginForm.username"
                      required
                      :disabled="isLoading"
                      autocomplete="username"
                      maxlength="100"
                    />
                    <div class="input-group-append">
                      <div class="input-group-text">
                        <span class="fas fa-user"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label>รหัสผ่าน</label>
                  <div class="input-group">
                    <input
                      id="password-input-login-view"
                      :type="showPassword ? 'text' : 'password'"
                      class="form-control form-control-sm"
                      v-model="loginForm.password"
                      required
                      :disabled="isLoading"
                      autocomplete="current-password"
                      maxlength="100"
                    />
                    <div class="input-group-append">
                      <div
                        class="input-group-text cursor-pointer"
                        @click="togglePassword"
                      >
                        <span
                          :class="
                            showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'
                          "
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-row class="mb-2">
              <b-col cols="12">
                <b-form-checkbox
                  size="sm"
                  v-model="loginForm.rememberMe"
                  @change="saveToLocalStorage"
                  :disabled="isLoading"
                  >จดจำฉัน</b-form-checkbox
                >
              </b-col>
            </b-row>
            <div class="row">
              <div class="col-12">
                <button
                  type="submit"
                  class="btn btn-primary btn-block btn-sm"
                  :disabled="
                    isLoading || !loginForm.username || !loginForm.password
                  "
                >
                  {{ isLoading ? "กำลังเข้าสู่ระบบ..." : "เข้าสู่ระบบ" }}
                </button>
              </div>
            </div>
          </b-form>
          <div class="row">
            <div class="col-12">
              <span class="mb-0 mt-3 ml-auto">
                <a href="/user/forgotpassword" class="text-center"
                  >ลืมรหัสผ่าน?</a
                >
              </span>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
    <Loading v-if="isLoading"></Loading>
    <Dialog ref="Dialog"></Dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loading from "@/components/Loading";
import Dialog from "@/components/modal/Dialog";
import { eventBus } from "@/main";
import { ERROR_MESSAGES } from "@/constants/errorMessages";

export default {
  name: "Login",
  components: {
    Loading,
    Dialog,
  },
  data() {
    return {
      isLoading: false,
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
      },
      statusLogin: false,
      showPassword: false,
      ERROR_MESSAGES, // Make error messages available in template
    };
  },
  created() {
    this.fetchAppVersion();
    this.loadFromLocalStorage();
  },
  beforeDestroy() {
    // Clear sensitive data
    this.loginForm.password = "";
  },
  computed: {
    ...mapGetters({
      appVersion: "moduleMaster/getAppVersion",
      getLoginApiStatus: "moduleAuth/getLoginApiStatus",
    }),
  },
  methods: {
    ...mapActions({
      login: "moduleUser/login",
      fetchAppVersion: "moduleMaster/fetchAppVersion",
      actionLoginApi: "moduleAuth/loginApi",
    }),

    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    async submit() {
      this.isLoading = true;
      try {
        const loginData = {
          username: this.loginForm.username.trim(),
          password: this.loginForm.password.trim(),
          rememberMe: this.loginForm.rememberMe,
        };

        const res = await this.actionLoginApi(loginData);

        if (res.status === 200) {
          // Clear sensitive data
          this.loginForm.password = "";

          // Redirect with priority: query.from > localStorage > default
          let redirectPath = "/clinic";

          if (this.$route.query.from) {
            // Priority 1: Redirect from axios interceptor
            redirectPath = this.$route.query.from;
          } else if (this.loginForm.rememberMe) {
            // Priority 2: Saved route from localStorage (only if rememberMe is enabled)
            const savedRoute = localStorage.getItem("lastAuthenticatedRoute");
            if (savedRoute) {
              redirectPath = savedRoute;
              // Clear saved route after using it
              localStorage.removeItem("lastAuthenticatedRoute");
            }
          }

          await this.$router.replace({ path: redirectPath });
        }
      } catch (err) {
        const statusCode = err.response?.data?.errorCode;

        if (statusCode === 401) {
          // Handle authentication errors locally (show inline warning)
          this.loginForm.password = "";
          this.statusLogin = true;
        } else {
          // Use global error system for all other errors (network, server, etc.)
          eventBus.$emit("apiError", err);
        }
      } finally {
        this.isLoading = false;
      }
    },

    setStatusLogin() {
      this.statusLogin = false;
    },

    saveToLocalStorage(value) {
      localStorage.setItem("rememberMe", value);

      // Clear saved route when Remember Me is unchecked
      if (!value) {
        localStorage.removeItem("lastAuthenticatedRoute");
      }
    },

    loadFromLocalStorage() {
      this.loginForm.rememberMe = Boolean(
        JSON.parse(localStorage.getItem("rememberMe"))
      );
    },

    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
  },
};
</script>

<style>
.cursor-pointer {
  cursor: pointer;
}
</style>